export type AnalyticsPayload = Record<string, unknown>

/**
 * Lightweight analytics logger. Uses navigator.sendBeacon when available,
 * otherwise falls back to a non-blocking fetch. Designed for simple click
 * events like outbound quick-links. This is intentionally minimal for the
 * UI prototype; integrate with real analytics backend in production.
 */
export function logEvent(eventName: string, payload: AnalyticsPayload = {}) {
  try {
    const body = JSON.stringify({ event: eventName, payload, ts: new Date().toISOString() })
    const url = '/analytics/track'
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      const blob = new Blob([body], { type: 'application/json' })
      navigator.sendBeacon(url, blob)
      return
    }

    // Fire-and-forget fetch; do not await
    if (typeof fetch !== 'undefined') {
      void fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body })
    }
  } catch (e) {
    // ignore analytics errors in UI
    // eslint-disable-next-line no-console
    console.debug('Analytics error', e)
  }
}
